import TweenMax from 'TweenMax'
import { select } from "@assets/scripts/utils";
import TimelineMax from 'TimelineMax'

export default function () {
    let svg = document.querySelector('.i1')

    if(!svg) return
    svg = svg.contentDocument

    // String 1
    const strings1Mask = svg.querySelector('.strings-1-mask')
    const s1 = new TimelineMax()
    s1.fromTo(strings1Mask, 0.9, { y: '-80%' }, { y: '0%', ease: SteppedEase.config(2) }).repeat(-1)

    // String 2
    const strings2Mask = svg.querySelector('.strings2mask')
    const s2 = new TimelineMax()
    s2.fromTo(strings2Mask, 1.2, { y: '-80%' }, { y: '0%', ease: SteppedEase.config(3) }).repeat(-1)

    // Robohand
    const robohand = svg.querySelector('.i1_robohand')
    const rh = new TimelineMax()
    rh.fromTo(robohand, 1.5, { y: '-5%' }, { y: '0%', ease: SteppedEase.config(3) }).repeat(-1)

    const crates = svg.querySelector('.i1__crates')
    const cratesTl = new TimelineMax()
    cratesTl.fromTo(crates, 1, { x: '0' }, { x: '-15', ease: SteppedEase.config(3) }).repeat(-1)

    // Gear
    const gear = svg.querySelector('.i1__gear')

    TweenMax
        .to(gear, 1, { rotation: 360, transformOrigin: '50% 50%', ease: SteppedEase.config(3) })
        .repeat(-1)


    // Lights
    const lights = select('#lights1 line', svg)
    const tll = new TimelineMax
    const lightsArray = [
        [8,9,0],
        [1,3,7],
        [2,4,5,9],
        [3,8,10],
        [1,2,6],
        [2,3,8],
        [0,7,10]
    ]
        .map(item => item.map(i => lights[i]))

    tll
        .add(() => {
            TweenMax.set(lights,{ autoAlpha: 0 })
            TweenMax.set(lightsArray[0], { autoAlpha: 1 })
        })
        .add(() => {
            TweenMax.set(lights,{ autoAlpha: 0 })
            TweenMax.set(lightsArray[1], { autoAlpha: 1 })
        }, 0.35)
        .add(() => {
            TweenMax.set(lights,{ autoAlpha: 0 })
            TweenMax.set(lightsArray[2], { autoAlpha: 1 })
        }, 0.7)
        .add(() => {
            TweenMax.set(lights,{ autoAlpha: 0 })
            TweenMax.set(lightsArray[3], { autoAlpha: 1 })
        }, 1.15)
        .add(() => {
            TweenMax.set(lights,{ autoAlpha: 0 })
            TweenMax.set(lightsArray[4], { autoAlpha: 1 })
        }, 1.5)
        .add(() => {
            TweenMax.set(lights,{ autoAlpha: 0 })
            TweenMax.set(lightsArray[5], { autoAlpha: 1 })
        }, 1.85)

    tll.repeat(-1)

}
